import Link from "next/link";
import React from "react";
//styles
import styles from "./loggedInNavItem.module.scss";
import classNames from "classnames";
import { truncateBracketedText } from "@/utils";

interface itemPropType {
  title: string;
  url: string;
  blueText?: boolean;
  onClick?: () => void;
  link?: boolean;
  lastItem?: boolean;
  user?: string;
}
const Item = ({
  title,
  url,
  blueText = false,
  link = false,
  onClick,
  lastItem = false,
  user,
}: itemPropType) => {
  return (
    <>
      {link ? (
        <Link
          href={url}
          className={classNames(styles["link-item"], styles.block)}
        >
          <p className={classNames(blueText && styles["text_blue"])}>{title}</p>
        </Link>
      ) : (
        <div
          onClick={() => {
            onClick && onClick();
          }}
          className={classNames(
            styles["link-item"],
            blueText && styles["text_blue"],
            lastItem && styles["last-item"]
          )}
        >
          {" "}
          <p className={classNames(blueText && styles["text_blue"])}>
            {title}
            {user && (
              <span className={classNames(styles.username)}>
                {truncateBracketedText(`(${user})`)}
              </span>
            )}
          </p>
        </div>
      )}
    </>
  );
};

export default Item;
